(function () {
  function initRoot(root) {
    var slides = root.querySelectorAll('[data-em-slide]');
    var thumbs = root.querySelectorAll('[data-em-thumb]');
    var lightbox = root.querySelector('[data-em-lightbox]');
    var lightboxImg = lightbox ? lightbox.querySelector('[data-em-lightbox-img]') : null;

    var current = 0;

    function activate(index) {
      index = String(index);
      current = parseInt(index, 10) || 0;
      slides.forEach(function (slide) {
        var on = slide.getAttribute('data-em-slide') === index;
        slide.classList.toggle('is-active', on);
        var video = slide.querySelector('video');
        if (!video) return;
        if (on) {
          video.muted = true;
          var playing = video.play();
          if (playing && playing.catch) playing.catch(function () {});
        } else if (!video.paused) {
          video.pause();
        }
      });
      thumbs.forEach(function (thumb) {
        thumb.classList.toggle('is-active', thumb.getAttribute('data-em-thumb') === index);
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        activate(thumb.getAttribute('data-em-thumb'));
      });
    });

    function step(dir) {
      var count = slides.length;
      if (!count) return;
      activate(String((current + dir + count) % count));
    }

    root.querySelectorAll('[data-em-nav]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        step(parseInt(btn.getAttribute('data-em-nav'), 10) || 1);
      });
    });

    var stage = root.querySelector('.em-gallery__stage');
    if (stage && slides.length > 1) {
      var touchX = 0;
      var touchY = 0;
      var touchLive = false;

      stage.addEventListener('touchstart', function (event) {
        if (event.touches.length !== 1) { touchLive = false; return; }
        touchX = event.touches[0].clientX;
        touchY = event.touches[0].clientY;
        touchLive = true;
      }, { passive: true });

      stage.addEventListener('touchend', function (event) {
        if (!touchLive) return;
        touchLive = false;
        var dx = event.changedTouches[0].clientX - touchX;
        var dy = event.changedTouches[0].clientY - touchY;
        if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
        step(dx < 0 ? 1 : -1);
      }, { passive: true });

      stage.addEventListener('touchcancel', function () { touchLive = false; }, { passive: true });
    }

    root.querySelectorAll('.em-specs-link[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var target = document.getElementById(link.getAttribute('href').slice(1));
        if (target) {
          event.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });

    if (!lightbox || !lightboxImg) return;

    function open(src, alt) {
      lightboxImg.src = src;
      lightboxImg.alt = alt || '';
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    }

    function close() {
      lightbox.classList.remove('is-open', 'is-zoomed');
      lightbox.setAttribute('aria-hidden', 'true');
      lightboxImg.removeAttribute('src');
      document.documentElement.style.overflow = '';
    }

    var zoomBtn = root.querySelector('[data-em-zoom-btn]');
    if (zoomBtn) {
      zoomBtn.addEventListener('click', function () {
        var slide = root.querySelector('.em-gallery__slide.is-active');
        var img = slide ? slide.querySelector('img[data-em-hd]') : null;
        if (!img) return;
        open(img.getAttribute('data-em-hd'), img.getAttribute('alt'));
      });
    }

    root.querySelectorAll('[data-em-zoom]').forEach(function (img) {
      img.addEventListener('click', function () {
        open(img.getAttribute('data-em-zoom'), img.getAttribute('alt'));
      });
    });

    lightbox.addEventListener('click', function (event) {
      if (event.target === lightbox || event.target.closest('[data-em-close]')) close();
    });

    lightboxImg.addEventListener('click', function (event) {
      event.stopPropagation();
      lightbox.classList.toggle('is-zoomed');
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && lightbox.classList.contains('is-open')) close();
    });
  }

  function init() {
    document.querySelectorAll('[data-em-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-em-root]');
    if (root) initRoot(root);
  });
})();
